export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
      console.log('start home js');
        function animateADN() {
            if ($('.margin-info-boxes').visible(true)) {
                $(".box-container .box-title, .box-container .box-description, .box-container .box-link").each(function (i, val) {
                    setTimeout(function () {
                        $(val).addClass("shown");
                    }, (i * 100));
                });
            }
        }

        function animateCustomersIcons() {
            if ($('.padding-client-slider').visible(true)) {
                $(".padding-client-slider .img-logo").each(function (i, val) {
                    setTimeout(function () {
                        $(val).addClass("shown");
                    }, (i * 100));
                });
            }
        }

        $(document).on("ready", function() {
          animateADN();
          animateCustomersIcons();
        });
        /*setTimeout(function () {
          animateADN();
          animateCustomersIcons();
        }, 500);*/

        var baseScroll = $(window).scrollTop();

        function boxesParallax() {
            var currentScroll = $(window).scrollTop();
            var wrapper = $(".case-wrapper").closest("div[class^='col-']");
            wrapper.each(function (i, val) {
                if (currentScroll > baseScroll) {
                    if ($(val).visible(true, true)) {
                        $(val).addClass("parallax");
                    }
                }
                if (currentScroll < baseScroll) {
                    if ($(val).visible(true, true) && ($(val).position().top + $(val).height()) > currentScroll) {
                        $(val).removeClass("parallax");
                    }
                }
            });
            baseScroll = currentScroll;
        }

        $(window).scroll(function () {
            if ($(window).width() >= 1024) {
                boxesParallax();
            }
            animateADN();
            animateCustomersIcons();
        });

        $('.row-clients-slider .client-slider-slick').slick({
            dots: false,
            speed: 1000,
            slidesToShow: 3,
            mobileFirst: true,
            infinite: true,
            swipe: true,
            touchMove: true,
            swipeToSlide: true,
            pauseOnFocus: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev-custom"><i class="fas fa-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next-custom"><i class="fas fa-chevron-right"></i></button>',
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        speed: 1000,
                        slidesToShow: 6,
                        mobileFirst: true,
                        infinite: true,
                        swipe: true,
                        touchMove: true,
                        swipeToSlide: true,
                        arrows: true,
                        autoplay: true,
                        autoplaySpeed: 2000,
                    },
                },
            ],
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js